/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
  TextProps,
} from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import { HowToUse } from '../../DealsDetails/components/HowToUse';

export function Label(props: TextProps) {
  return <Text color="#000000" fontFamily={'Glory'} fontWeight={'400'} fontSize={14} {...props} />;
}

export function InfoModal({
  isOpen,
  onClose,
  how_to_use,
  showName
}: {
  how_to_use: string;
  showName: string;
  isOpen: boolean;
  onClose: () => void;
}) {
  const { colors } = useTheme();

  return (
    <Modal
      onClose={() => {
        onClose();
      }}
      isCentered
      id="virtual-card-modal"
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent margin={'20px'} padding="15px 5px" borderRadius={'16px'}>
        <ModalHeader>Como usar</ModalHeader>
        <ModalCloseButton color={colors.primaryColor} />
        <ModalBody width={'100%'}>
          <Label dangerouslySetInnerHTML={{ __html: how_to_use.replaceAll("\n", "<br/>") }}></Label>
          <HowToUse name={showName} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
